export const cpfClearMask = value => {
    return value
        .replace('.', '')
        .replace('.', '')
        .replace('-', '')
}